import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Col, Form, Row } from "react-bootstrap";
import { post } from "../../../helpers/api_helper";
import { Spin } from "antd";
import { successMessage, errorMessage } from "../CommonFunctions";
import {
  POST_InventoryItemReturnInsert,
  POST_GetEmployeeDDLList,
  POST_GetInventoryItemIssueDDLListByID,
} from "../../../helpers/url_helper";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import moment from "moment";
import CustomInput from "../../../CustomControls/CustomInput";

const AddInventoryItemReturn = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const [employeeOptions, setEmployeeOptions] = useState([]);

  useEffect(() => {
    getEmployeeDDL();
  }, []);

  const getEmployeeDDL = async () => {
    setIsLoading(true);
    await post(POST_GetEmployeeDDLList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      UserType: AuthUser?.UserType,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setEmployeeOptions(
            response?.EmployeeList?.map((item) => ({
              label: item.EmployeeName,
              value: item.EmployeeIDEncrypted,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const validationSchema = Yup.object().shape({
    IssueToEmployeeIDEncrypted: Yup.string()
      .trim()
      .required("Issue To Employee is required field"),
    ReturnByEmployeeIDEncrypted: Yup.string()
      .trim()
      .required("Return To Employee is required field"),
    ReturnDate: Yup.string().required("Return Date is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      InventoryItemIssueIDEncrypted: "",
      InventoryItemStockIDEncrypted: "",
      InventoryItemIDEncrypted: "",
      IssueToEmployeeIDEncrypted: "",
      ReturnByEmployeeIDEncrypted: "",
      ListOfItem: [],
      ReturnDate: new Date(),
      Remarks: "",
      ItemReturnNumber: "",
    },
    validateOnBlur: false,
  });

  const {
    setFieldValue,
    values: { ListOfItem },
  } = formik;

  const handleValidSubmit = (values) => {
    const uniqueNumber = generateUniqueNumber(); // each time different

    if (values?.ListOfItem?.filter((x) => x?.IsSelected == true).length == 0) {
      formik.setFieldError("ListOfItem", "Please select Item Issue Detail...");
      formik.setFieldTouched("ListOfItem", true);
      return;
    }

    let IsItemValid = false;
    let IsItemValidPendingReturnQty = false;

    Promise.all(
      values?.ListOfItem?.filter((x) => x?.IsSelected == true)?.map((test) => {
        if (!test?.TotalReturnQty || test?.TotalReturnQty == 0) {
          IsItemValid = true;
        }
      })
    );

    Promise.all(
      values?.ListOfItem?.filter((x) => x?.IsSelected == true)?.map((test) => {
        if (test?.TotalReturnQty > test?.TotalPendingReturnQty) {
          IsItemValidPendingReturnQty = true;
        }
      })
    );

    if (IsItemValid) {
      formik.setFieldError(
        "ListOfItem",
        "Please fill Selected Item Return Qty..."
      );
      formik.setFieldTouched("ListOfItem", true);

      // setIsLoading(false);
      return;
    }

    if (IsItemValidPendingReturnQty) {
      formik.setFieldError(
        "ListOfItem",
        "Return Qty cannot be greater than Pending Return Qty."
      );
      formik.setFieldTouched("ListOfItem", true);

      // setIsLoading(false);
      return;
    }

    setIsLoading(true);

    let payload = {
      ReturnDate: values?.ReturnDate,
      Remarks: values?.Remarks,
      ReturnByEmployeeIDEncrypted: values?.ReturnByEmployeeIDEncrypted,
      ItemReturnNumber: values?.ItemReturnNumber
        ? values?.ItemReturnNumber.toString()
        : uniqueNumber,

      Listuddt: values?.ListOfItem?.filter((x) => x.IsSelected == true)?.map(
        (item) => {
          return {
            InventoryItemStockIDEncrypted: item?.InventoryItemStockIDEncrypted,
            InventoryItemIDEncrypted: item?.InventoryItemIDEncrypted,
            InventoryItemIssueIDEncrypted: item?.InventoryItemIssueIDEncrypted,
            InventoryItemReturnIDEncrypted: item?.InventoryItemReturnIDEncrypted
              ? item?.InventoryItemReturnIDEncrypted
              : "",
            TotalReturnQty: item?.TotalReturnQty,
            IsConsumable: item?.IsConsumable,
            IsDelete: item?.IsDelete,
          };
        }
      ),

      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };

    //console.log("payload", payload);
    //return;

    post(POST_InventoryItemReturnInsert, payload)
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/item-return");
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const generateUniqueNumber = () => {
    const now = new Date();
    return moment(now).format("YYYYMMDDHHmmssSSS"); // 17 digits
  };

  const GetItemIssueDetail = (id) => {
    formik.setFieldValue(`ListOfItem`, []);
    setIsLoading(true);
    post(POST_GetInventoryItemIssueDDLListByID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      IssueToEmployeeIDEncrypted: id,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          // formik.setFieldValue(`ListOfItem`, response?.List);

          formik.setFieldValue(
            "ListOfItem",
            response?.List?.map((item) => ({
              ...item,
              TotalReturnQty:
                item?.TotalReturnQty > 0
                  ? item?.TotalReturnQty
                  : item?.TotalPendingReturnQty,
              IsDelete: false,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">
                {PrimaryIdParam ? "Edit" : "Add"} Item Return
              </h4>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0">
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Row>
                    <Col lg={3}>
                      <Field
                        label="Issue To Employee"
                        name="IssueToEmployeeIDEncrypted"
                        placeholder={"Select Issue To Employee"}
                        options={employeeOptions}
                        component={CustomSelect}
                        isClearable={false}
                        required
                        onChange={(e) => {
                          formik.setFieldValue(
                            "IssueToEmployeeIDEncrypted",
                            e?.value ?? ""
                          );
                          GetItemIssueDetail(e?.value ?? "");
                        }}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        label="Return Date"
                        name="ReturnDate"
                        placeholder={"Select Return Date"}
                        component={CustomFlatpickr}
                        options={{
                          altInput: true,
                          altFormat: "j-M-Y",
                          dateFormat: "d-m-Y",
                          maxDate: new Date(),
                        }}
                        required
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        label="Return To Employee"
                        name="ReturnByEmployeeIDEncrypted"
                        placeholder={"Select Return To Employee"}
                        options={employeeOptions}
                        component={CustomSelect}
                        isClearable={false}
                        required
                        onChange={(e) => {
                          formik.setFieldValue(
                            "ReturnByEmployeeIDEncrypted",
                            e?.value ?? ""
                          );
                        }}
                      />
                    </Col>
                    <Col lg={3}>
                      <Field
                        name={"Remarks"}
                        label={"Remarks"}
                        placeholder={"Remarks"}
                        component={CustomTextArea}
                        rows={4}
                        maxLength={2000}
                      />
                    </Col>
                  </Row>
                  <hr className="mt-1 mb-2"></hr>

                  <Row>
                    <Col lg={12}>
                      <div className="card-header p-2">
                        <h4 className="card-title">Item Issue Detail</h4>
                      </div>
                      <div className="card-body p-1">
                        <ErrorMessage
                          name={"ListOfItem"}
                          component="div"
                          className="invalid-feedback animated fadeInUp"
                          style={{ display: "block" }}
                        />
                        <div className="table-responsive active-projects style-1 shorting">
                          <div
                            id="ItemDetail-tbl_wrapper"
                            className="dataTables_wrapper table-responsive no-footer "
                            style={{ overflowY: "auto" }}
                          >
                            <table
                              id="ItemDetail-tbl"
                              className="table dataTable no-footer mb-0 "
                            >
                              <thead className="fixedheader">
                                <tr>
                                  <th width="3%"></th>
                                  <th width="8%">Return Qty</th>
                                  <th width="10%">Pending Return Qty</th>
                                  <th width="8%">Total Qty</th>
                                  <th width="10%">Issue Number</th>
                                  <th width="8%">Issue Date</th>
                                  <th width="20%">Item Name</th>
                                  <th width="12%">Unit Name</th>
                                  <th width="12%">Item Type</th>
                                  <th
                                    style={{
                                      width: "9%",
                                      textAlign: "left",
                                    }}
                                  >
                                    Unit Price
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {ListOfItem?.length > 0 ? (
                                  ListOfItem?.map((item, indx) => (
                                    <tr key={indx}>
                                      <td
                                        style={{
                                          textAlign: "center",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id={`chkReturn${indx}`}
                                          name={`chkReturn${indx}`}
                                          checked={item.IsSelected}
                                          onChange={(e) => {
                                            formik.setFieldValue(
                                              `ListOfItem[${indx}].IsSelected`,
                                              e?.target?.checked
                                            );
                                          }}
                                        />
                                      </td>
                                      <td>
                                        <Field
                                          type="number"
                                          name={`ListOfItem.[${indx}].TotalReturnQty`}
                                          component={CustomInput}
                                          placeholder="Return Qty"
                                          noMarginBottom={true}
                                          style={{ width: "250px" }}
                                        />
                                      </td>
                                      <td>{item?.TotalPendingReturnQty}</td>
                                      <td>{item?.TotalReturnebleQty}</td>
                                      <td>{item?.ItemIssueNumber}</td>
                                      <td>{item?.IssueDate}</td>
                                      <td>{item?.ItemName}</td>
                                      <td>{item?.ConsumptionUnit}</td>
                                      <td>{item?.ItemTypeName}</td>
                                      <td style={{ textAlign: "left" }}>
                                        {item?.UnitPrice}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={10}
                                      style={{ textAlign: "left" }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <hr className="mt-1 mb-2"></hr>
                  <button type="submit" className="btn btn-primary btn-sm me-2">
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={(e) => {
                      navigate(-1);
                    }}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </Form>
              </FormikProvider>
            </div>
          </Spin>
        </div>
      </div>
    </>
  );
};

export default AddInventoryItemReturn;
